/**
 * Superagent/admin shell.
 *
 * NOTE: this has no Flutter counterpart. In the Flutter app the admin surface is
 * a tab inside the LANDLORD shell (`/landlord/users` -> UserManagementScreen,
 * app_router.dart:207-210) and a superagent's home is `/landlord`
 * (app_router.dart:86). This shell is scaffolding for a possible future split;
 * nothing redirects here by default — see homePathForRole in src/routes/paths.ts.
 *
 * Before building pages under it, note that the user-management screen's write
 * operations have no backend behind them on EITHER stack: `PATCH`/`DELETE
 * auth/{id}/` are unrouted in Django and Node alike (refactor/docs/PARITY_NOTES.md,
 * "`PATCH`/`DELETE /api/auth/{id}/` are 404 in both backends"). Only the user
 * LIST (`GET auth/`) and user CREATE (`POST auth/register/` as a superagent)
 * exist today.
 */
import { Dashboard, UserMultiple } from '@carbon/icons-react';
import { ShellFrame, type NavItem } from './ShellFrame';

const NAV_ITEMS: readonly NavItem[] = [
  { label: 'Overview', to: '/admin', end: true, icon: Dashboard },
  { label: 'Users', to: '/admin/users', icon: UserMultiple },
];

export function AdminShell(): React.JSX.Element {
  return <ShellFrame title="Administration" navItems={NAV_ITEMS} />;
}

export default AdminShell;
